import { createSlice } from "@reduxjs/toolkit";
import { tareaEnviadaParaAnalizar } from "../js/actions";
import { ETipoPersona, EEstadoTareaOperacion } from "domain/types";

const initialState = {
  isLoading: false,
  submitIsLoading: false,
  error: false,
  identidadError: false,
  complete: false,
  dni: null,
  sexo: null,
  nombres: null,
  apellidos: null,
  fechaNacimiento: null,
  cuil: null,
  actividad: null,
  rubro: null,
  antiguedad: null,
  ingresos: 0,
  identidadPersonas: null,
  personaSeleccionada: null,
  telefono: null,
};

const tareaConyugeSlice = createSlice({
  name: "tareaConyuge",
  initialState,
  reducers: {
    tareaConyugeSetDni: (state, action) => {
      state.dni = action.payload;
      state.complete = false;
    },
    tareaConyugeSetSexo: (state, action) => {
      state.sexo = action.payload;
      state.complete = false;
    },
    tareaConyugeFetchIdentidadInited: (state) => {
      state.isLoading = true;
      state.nombres = null;
      state.apellidos = null;
      state.fechaNacimiento = null;
      state.cuil = null;
      state.actividad = null;
      state.rubro = null;
      state.antiguedad = null;
      state.ingresos = 0;
      state.complete = false;
      state.identidadPersonas = null;
      state.personaSeleccionada = null;
      state.telefono = null;
    },
    tareaConyugeFetchIdentidadCompleted: (state, action) => {
      const response = action.payload;
      const tieneMultiplesPersonas = response.personas?.length > 1;

      state.isLoading = false;
      state.identidadError = false;
      state.complete = false;
      state.identidadPersonas = response;

      if (!tieneMultiplesPersonas) {
        const persona = response.personas?.[0] || response;
        state.nombres = persona.nombres;
        state.apellidos = persona.apellido;
        state.fechaNacimiento = persona.fechaNacimiento;
        state.cuil = persona.cuil;
      }
    },
    tareaConyugeFetchIdentidadFailed: (state) => {
      state.isLoading = false;
      state.identidadError = true;
      state.complete = false;
    },
    tareaConyugeSetPersonaSeleccionada: (state, action) => {
      const persona = action.payload;
      state.personaSeleccionada = persona;
      state.nombres = persona.nombres;
      state.apellidos = persona.apellido;
      state.fechaNacimiento = persona.fechaNacimiento;
      state.cuil = persona.cuil;
      state.complete = false;
    },
    tareaConyugeSetActividad: (state, action) => {
      state.actividad = action.payload;
      state.rubro = null;
      state.antiguedad = null;
      state.complete = false;
    },
    tareaConyugeSetRubro: (state, action) => {
      state.rubro = action.payload;
      state.antiguedad = null;
      state.complete = false;
    },
    tareaConyugeSetAntiguedad: (state, action) => {
      state.antiguedad = action.payload;
      state.complete = false;
    },
    tareaConyugeSetIngresos: (state, action) => {
      state.ingresos = action.payload;
      state.complete = false;
    },
    tareaConyugeSetComplete: (state, action) => {
      state.complete = action.payload;
    },
    tareaConyugeClear: () => initialState,
    tareaConyugeSetTelefono: (state, action) => {
      state.telefono = action.payload;
    },
    submitTareaConyugeInited: (state) => {
      state.submitIsLoading = true;
    },
    submitTareaConyugeCompleted: (state) => {
      state.submitIsLoading = false;
    },
    submitTareaConyugeFailed: (state) => {
      state.submitIsLoading = false;
      state.error = true;
    },
  },
});

export const {
  tareaConyugeSetDni,
  tareaConyugeSetSexo,
  tareaConyugeFetchIdentidadInited,
  tareaConyugeFetchIdentidadCompleted,
  tareaConyugeFetchIdentidadFailed,
  tareaConyugeSetActividad,
  tareaConyugeSetRubro,
  tareaConyugeSetAntiguedad,
  tareaConyugeSetIngresos,
  tareaConyugeSetComplete,
  tareaConyugeClear,
  submitTareaConyugeInited,
  submitTareaConyugeCompleted,
  submitTareaConyugeFailed,
  tareaConyugeSetPersonaSeleccionada,
  tareaConyugeSetTelefono,
} = tareaConyugeSlice.actions;

export const fetchIdentidad = (dni, sexo) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(tareaConyugeFetchIdentidadInited());
      const response = await services.api.getIdentidad(dni, sexo);
      dispatch(tareaConyugeFetchIdentidadCompleted(response));
    } catch (error) {
      dispatch(tareaConyugeFetchIdentidadFailed(error));
    }
  };
};

export const submitTareaConyuge = (solicitudId, tarea, comentario) => {
  return async (dispatch, getState, services) => {
    try {
      const conyuge = getState().TareaConyugeReducer;
      let tareaUpdated = JSON.parse(JSON.stringify(tarea));

      let request = "";
      if (conyuge && conyuge.complete) {
        let data = JSON.stringify({
          Nombre: conyuge.nombres + " " + conyuge.apellidos,
          Documento: conyuge.dni,
          ActividadDeclarada: conyuge.actividad && conyuge.actividad.label,
          FechaNacimiento: conyuge.fechaNacimiento,
          Ingreso: conyuge.ingresos,
        });
        request = {
          Sequence: tarea.sequence,
          Comentario: comentario,
          data: data,
          conyuge: {
            nombreConyuge: conyuge.nombres,
            apellidoConyuge: conyuge.apellidos,
            DocumentoConyuge: conyuge.dni,
            SexoConyuge: conyuge.sexo && conyuge.sexo.value,
            Cuil: conyuge.cuil,
            ActividadDeclarada: conyuge.actividad && conyuge.actividad.value,
            Antiguedad: conyuge.antiguedad && conyuge.antiguedad.value,
            FechaNacimiento: conyuge.fechaNacimiento,
            Ingreso:
              conyuge.ingresos &&
              conyuge.ingresos.replace("$", "").replace(".", ""),
          },
        };
        tareaUpdated.data = data;
      } else {
        request = {
          sequence: tarea.sequence,
          comentario: comentario,
        };
      }
      //Actualizo el contenido de la tarea
      if (comentario) {
        tareaUpdated.log.push({ comentario: comentario, usrExterno: true });
      }
      tareaUpdated.estado = EEstadoTareaOperacion.Para_Analizar;

      const telefono = getState().TareaConyugeReducer.telefono;
      if (telefono && telefono.numero && telefono.isValid) {
        request.conyuge.Telefonos = [
          {
            Numero: telefono.numero,
            TipoTelefono: telefono.tipoContacto || "Particular",
            EsMovil: telefono.esMovil,
            HorarioContacto: telefono.horarioContacto || "Todo_El_Dia",
            TipoPersona: ETipoPersona.Conyuge,
          },
        ];
      }

      dispatch(submitTareaConyugeInited());
      await services.api.postTareaConyuge(solicitudId, request);
      dispatch(tareaEnviadaParaAnalizar(tareaUpdated));
      dispatch(submitTareaConyugeCompleted());
    } catch (error) {
      console.error(error);
      dispatch(submitTareaConyugeFailed(error));
    }
  };
};

export default tareaConyugeSlice.reducer;
